/** Publik bas-adress. Används för canonical, og:url och delningslänkar. */
export const SITE_URL = "https://sellavo.com";

/** Gör en absolut adress av en intern sökväg. */
export function abs(path: string): string {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

/**
 * Delningslänk för en sida. Vi delar alltid den publika adressen
 * (sellavo.com) även om användaren surfar på en förhandsvisning.
 */
export function shareUrl(pathname: string): string {
  return abs(pathname);
}
